export const FILE_EXTENSION_BLACK_LIST = ['heic']